import { Provider } from '@angular/core';
import { MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS, MatDateFormats } from '@angular/material/core';

export function provideMatDateFormats(): Provider {
  return {
    provide: MAT_DATE_FORMATS,
    useValue: {
      ...MAT_NATIVE_DATE_FORMATS,
      display: {
        ...MAT_NATIVE_DATE_FORMATS.display,
        dateInput: {
          year: '2-digit',
          month: 'short',
          day: '2-digit'
        }
      }
    } as MatDateFormats
  };
}
